import { gql } from "../../../../generated-graphql";

export const WORKFLOW_ACTIVITIES_QUERY = gql(`
  query WorkflowActivities($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!], $includeAllStaffActivities: Boolean) {
      workflowActivities(search: $search, page: $page, pageSize: $pageSize, sort: $sort, includeAllStaffActivities: $includeAllStaffActivities) {
          items {
            id
            activityId
            workflowId
            cohortId
            tierIIReportId
            activityType
            activityStatus
            name
            reportingYear
            reportKind
            organizationName
            tenantId
            assigneeEmail
            credentials {
                username
                verificationStatus
            }
            activityCreatedAt
            activityUpdatedAt
            errorMessage
            plan
            tags
            jobStatus
            description
            partnerTenantName
            cohortReadyMemberCount
            cohortTotalMemberCount
            cohortType
            workflowType
            facilityAddress
            workflowStatus
            state
            county
            stateEnabled
            fulfillmentNote
            csmName
            csmEmail
            amName
            amEmail
            dataManagerName
            dataManagerEmail
            wasteManagerName
            wasteManagerEmail
            pocName
            pocEmail
            jurisdictionType
            chemicalCount
          }
          count
      }
  }
  `);
